"use client";
import React, { useEffect, useRef, useState } from "react";
import { Box } from "@dxp-feed/ui/Box";
import { Text } from "@dxp-feed/ui/Text";
import EmblaSlider from "@/components/EmblaSlider";
import FeaturedOffersCard from "../offers/_components/JustForYouCards/FeaturedOffersCard";
import ImageWrapper from "@/components/ImageWrapper";
import { useAppSelector } from "@/utils/hooks/reactUseCustomHooks";

export default function EmblaExclusiveSlider({
  activeOffers,
  addedToListOffers,
  onVisibilityChange,
  openDialog,
  isOfferLoaded,
}: any) {
  const itemRefs = useRef<Record<string, HTMLDivElement | null>>({});
  const [readyToObserve, setReadyToObserve] = useState(false);
  const managementListData: any = useAppSelector(
    (state) => state?.manageListSlice
  );

  const favouriteList: any = useAppSelector(
    (state) => state?.favouriteProductSlice
  );

  useEffect(() => {
    if (!activeOffers?.length) return;
    const timeout = setTimeout(() => setReadyToObserve(true), 200);
    return () => clearTimeout(timeout);
  }, [activeOffers]);

  useEffect(() => {
    if (!readyToObserve || !onVisibilityChange) return;

    const observers: IntersectionObserver[] = [];

    activeOffers.forEach((offer: any) => {
      const el = itemRefs.current[offer.offerId];
      if (!el) return;

      const observer = new IntersectionObserver(
        ([entry]) => {
          console.log(
            `[Observer] ${offer.offerId} visible:`,
            entry.isIntersecting
          );
          onVisibilityChange(
            {
              item_id: offer.offerId,
              item_name: offer.description,
              affiliation: "Personalized offers",
            },
            entry.isIntersecting
          );
        },
        { threshold: 0.5 }
      );

      observer.observe(el);
      observers.push(observer);
    });

    return () => observers.forEach((obs) => obs.disconnect());
  }, [readyToObserve, activeOffers, onVisibilityChange]);

  return (
    <Box as="div" className="exclusive-slider">
      {activeOffers?.length > 0 && !isOfferLoaded ? (
        <EmblaSlider
          align="center"
          options={{ loop: false, align: "start", dragFree: true }}
          slidesPerView={{ base: 6, sm: 2, md: 4, lg: 4, xl: 5, xxl: 6 }}
          slidesToScroll={{ base: 6, sm: 2, md: 4, lg: 4, xl: 5, xxl: 6 }}
          showControls={true}
          thumbnails={false}
          className="embla_ExclusiveSlider"
        >
          {activeOffers?.slice(0, 15).map((offer: any, index: number) => {
            const obj = addedToListOffers?.find(
              (addedOffer: any) => addedOffer?.offer_id === offer?.offerId
            );

            return (
              <Box
                as="div"
                key={offer.regionalFlag + index}
                id={offer?.id}
                ref={(el) => {
                  itemRefs.current[offer.offerId] = el;
                }}
                className="px-[0px] offersinner mb-[0px] w-full rounded-[12px] bg-white flex items-stretch h-full"
              >
                <Box as="div" className="offerCarousal w-full">
                  <FeaturedOffersCard
                    featuredCardData={offer}
                    offerAddedInList={(managementListData?.itemsList?.length == 0 || (managementListData?.itemsList?.length == 1 && favouriteList?.listName == "Favourites")) ? 0 : obj ? 1 : 0}
                    openDialog={openDialog}
                  />
                </Box>
              </Box>
            );
          })}
        </EmblaSlider>
      ) : (
        <Box
          as="div"
          className="relative flex w-full items-center justify-center p-0 m-0"
        >
          <Box
            as="div"
            className="w-full bg-[url(/offers/just-for-you-bg.png)] grayscale bg-cover bg-no-repeat h-full min-h-[180px] md:min-h-[200px] lg:min-h-[250px] opacity-55"
          />
          <Box
            as="div"
            style={{
              background:
                "linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 35%)",
            }}
            className="absolute w-full h-[180px] md:h-[250px] flex overflow-hidden justify-center items-center"
          >
            <Text
              as="div"
              className="text-center text-brandBlack py-0 absolute text-sm sm:text-xl xl:text-3xl font-extrabold mb-0"
            >
              <ImageWrapper
                className="w-full max-w-[40px] lg:max-w-[50px] xl:max-w-[58px] mx-auto mb-2 xl:mb-[26px]"
                src={"/offers/just-for-you-percent-img.svg"}
                width={58}
                height={58}
                alt=""
              />
               <h2 className=" text-xl lg:text-3xl font-raleway mb-2 xs:mb-4">Currently, there are no offers available.</h2>
              <p className="mb-6 text-body font-normal">Please check back again next week for your offers.</p>
            </Text>
          </Box>
        </Box>
      )}
    </Box>
  );
}
